import React from "react"
import parse from "html-react-parser"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const renderItem = (item, id) => {
  return (
    <div key={id} className="w-full px-[16px] md:px-[124px] lg:px-px1_l xl:px-px1_xl">
      {/* Flex Container */}
      <div
        className="flex flex-col lg:flex-row w-full md:max-w-[600px] lg:max-w-w2_l xl:max-w-w2_xl items-center justify-between lg:gap-[32px] mx-auto"
      >
        {/* Left side: Text content */}
        <div className="flex flex-col flex-0 w-full lg:w-[50%] xl:w-[60%] max-w-[600px] items-start justify-center">
          <Typography
            component="h2"
            variant="h1"
            className="text-center lg:text-left mb-[20px] md:mb-[30px] xl:mb-[10px]"
          >
            {parse(item.title)}
          </Typography>

          <Typography 
            variant="body1"
            className="text-center lg:text-left"
          >
            {parse(item.description[0])}
          </Typography>

          <Typography 
            variant="body1"
            className="text-center lg:text-left"
          >
            {parse(item.description[1])}
          </Typography>
        </div>

        {/* Right side: Video and Video Placeholder */}
        <div className="w-full lg:w-[50%] xl:max-w-[740px] aspect-[740/502] rounded-[50px] overflow-hidden mt-[20px] md:mt-[46px] lg:mt-0">
          <video
            playsInline
            autoPlay
            muted
            loop
            className="w-full h-full object-cover"
          >
            <source src={item.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  )
}

const PartnershipSection = () => {
  return (
    <CMSRender
      contentType={"VideoPageSection"}
      match={{ "content.name": "HomePagePartnershipSection" }}
      renderItem={renderItem}
    />
  )
}

export default PartnershipSection
